const hamburgerSVG = `
<svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 2H25" stroke="#74F8CC" stroke-width="4" stroke-linecap="round"/>
<path d="M7 21H25" stroke="#74F8CC" stroke-width="4" stroke-linecap="round"/>
<path d="M2 11H20" stroke="#74F8CC" stroke-width="4" stroke-linecap="round"/>
</svg>
`

export default hamburgerSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/hamburgerSVG.js